import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { buscarProdutosEstabelecimento, atualizarProdutosEstabelecimento } from '../../services/api';
// import { Mask } from 'react-mask';
import Mask from 'react-input-mask';
// css
import 'bootstrap/dist/css/bootstrap.min.css';
import "./MeusProdutosPage.css";
import '../../styles/global.css';
import Carregando from '../../components/Carregando/Carregando';

const MeusProdutosPage = () => {

    const navigate = useNavigate();
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const BASE_URL = JSON.parse(sessionStorage.getItem('BASE_URL'));

    const [produtosEstabelecimento, setProdutosEstabelecimento] = useState([]);
    const [formData, setFormData] = useState({});
    const [produtosFormData, setProdutosFormData] = useState({});

    const [carregando, setCarregando] = useState(false);    

    // Array de departamentos
    const departamentos = ['BAR', 'COZINHA'];


    // carregar dados dos produtos, no formData
    useEffect(() => {
        setCarregando(true);

        if (produtosEstabelecimento.length > 0) {
            const produtosFormDataInicial = {};
            // varrer os produtos do estabelecimento e atribuir os dados
            produtosEstabelecimento.forEach((produto, index) => {

                produtosFormDataInicial[`nome_departamento-${index}`] = produto.nome_departamento;
                produtosFormDataInicial[`preco_venda-${index}`] = produto.preco_venda;
                produtosFormDataInicial[`qtd_minima_estoque-${index}`] = produto.qtd_minima_estoque;
                produtosFormDataInicial[`qtd_estoque-${index}`] = produto.qtd_estoque;
                produtosFormDataInicial[`descricao-${index}`] = produto.descricao;

            });
            setProdutosFormData(produtosFormDataInicial);
            setCarregando(false);
        } else {
            setProdutosFormData({});
            setCarregando(false);
        }
        setCarregando(false);
    }, [produtosEstabelecimento]);

    // buscar produtos do estabelecimento
    useEffect(() => {
        setCarregando(true);

        console.log('--- ENTROU EM MEUS PRODUTOS PAGE ----');
        
        if (userData) {

          const buscarProdutos = async () => {
            try {
              if (userData.statusUsuario === 'logado') {
      
                // const idEstabelecimento = userData.dadosEstabelecimento.id;
      
                // buscar todos os produtos do estabelecimento
                await fetchProdutosEstabelecimento();

                setCarregando(false);
      
              } else {
                setCarregando(false);
                console.log('Usuário não está logado, mantendo na área restrita.');
              }
            } catch (error) {
                setCarregando(false);
              console.error('Erro ao parsear os dados de usuário:', error);
            }
          };
      
          buscarProdutos();

        } else {
          console.log('Usuário NÃO está logado!');
        }
    }, []);

    // Função para redirecionar para MeusProdutosPage
    const handleGoToProdutos = async (e) => {
        e.preventDefault();
        navigate('/produtos');
    };



    // buscar todos os produtos do estabelecimento, para checkar os que já tem
    const fetchProdutosEstabelecimento = async () => {
        setCarregando(true);
        console.log('Entrou em fetchProdutosEstabelecimento em MeusProdutosPage');
        try {
            const dados = await buscarProdutosEstabelecimento(userData);

            console.log('*** produtos estab ***', dados.produtosEstabelecimento);

            if (dados?.produtosEstabelecimento) {

                console.log('-> Produtos recebidos: ');
                console.log(dados.produtosEstabelecimento[0]);
                console.log(dados.produtosEstabelecimento[1]);
                // vamos setar os produtos do estabelecimento
                setProdutosEstabelecimento(dados.produtosEstabelecimento);
            }

            setCarregando(false);

        } catch (error) {
            setCarregando(false);
            console.error('Erro ao buscar produtos:', error);
        }
    };

    // função pra formatar o preço
    const handlePrecoChange = useCallback((event, index) => {
        const valor = event.target.value;
        const valorFormatado = valor.replace(/\D/g, '').replace(/(\d)(\d{2})$/, '$1,$2');
        setFormData((prevFormData) => ({
            ...prevFormData,
            [`preco_venda-${index}`]: valorFormatado,
        }));
    }, [setFormData]);

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({ ...formData, [name]: value });
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProdutosFormData({ ...produtosFormData, [name]: value });
    };

    const handleSubmit = async (e) => {
        setCarregando(true);
        console.log('!! Entrou no submit !!');
        e.preventDefault();
        try {
          const formDataAtualizado = { ...formData, ...produtosFormData };
          const produtos = [];
          produtosEstabelecimento.forEach((produto, index) => {

            produtos.push({
              
              id_produto_estabelecimento: produto.id,
              produto_id: produto.produto_id,
              nome_departamento: formDataAtualizado[`nome_departamento-${index}`],
              preco_venda: formDataAtualizado[`preco_venda-${index}`],
              qtd_minima_estoque: formDataAtualizado[`qtd_minima_estoque-${index}`],
              qtd_estoque: formDataAtualizado[`qtd_estoque-${index}`],
              descricao: formDataAtualizado[`descricao-${index}`],

            });

          });
          const response = await atualizarProdutosEstabelecimento(produtos);
          console.log('Produtos atualizados com sucesso:', response);
          alert('Produtos atualizados com sucesso!');
          setCarregando(false);
          navigate('/bar-gerente');
        } catch (error) {
          console.error('Erro ao atualizar os produtos:', error);
          // Exibe a mensagem de erro vinda da API
          const errorMessage = error.response?.data?.message || 'Erro ao atualizar os produtos. Tente novamente.';
          alert(errorMessage);
          setCarregando(false);
        }
      };


      if (carregando) {
        return <Carregando />;
      }
    
      return (
        <div className="form-cadastrar-container">
            <TituloComponent />

            <form onSubmit={handleSubmit}>
                <h2 className="form-title">Cadastro de Produtos</h2>

                <div className="box-dados">
                    {/* Exibe o nome do perfil do usuário */}
                    <p className="texto-welcome">Você está em { userData.dadosEstabelecimento.nome }!</p>
                    {/* Botão Produtos */}
                    <button type='button' className="welcome-btn" onClick={handleGoToProdutos}>Voltar para Produtos</button>
                </div>

                <h2 className="form-title">Produtos do Estabelecimento</h2>

                <table className="table table-striped">
                    <tbody>

                        {produtosFormData && produtosEstabelecimento.length > 0 ? (
                            produtosEstabelecimento.map((produto, index) => (

                            <tr key={index}>
                                <td>
                                    {produto?.caminhoImagemProduto ? (
                                        <img src={BASE_URL + produto.caminhoImagemProduto} alt={produto.nome} width="60px" />
                                    ) : (
                                        'Imagem não disponível'
                                    )}
                                </td>
                                <td>
                                    {produto?.nome || 'Não informado'}

                                    <div className="form-cadastrar-container">


                                        <div className="form-group">
                                            <label htmlFor={`nome_departamento-${index}`}>Departamento</label>
                                            <select
                                                id={`nome_departamento-${index}`}
                                                name={`nome_departamento-${index}`}
                                                className="form-control"
                                                value={produtosFormData[`nome_departamento-${index}`] ?? 0}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Selecione o departamento do produto</option>
                                                {["BAR", "COZINHA"].map((nome_departamento) => (
                                                    <option key={nome_departamento} value={nome_departamento}>
                                                        {nome_departamento}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>


                                        <div className="form-group">
                                            <label htmlFor={`preco_venda-${index}`}>Preço R$</label>
                                            <input
                                                type="text"
                                                id={`preco_venda-${index}`}
                                                name={`preco_venda-${index}`}
                                                className="form-control"
                                                placeholder="Preço do produto"
                                                // value={produtosFormData[`preco_venda-${index}`] !== undefined ? produtosFormData[`preco_venda-${index}`] : 0}
                                                value={produtosFormData[`preco_venda-${index}`] ?? 0}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor={`qtd_minima_estoque-${index}`}>Qtd mínima</label>
                                            <input
                                                type="text"
                                                id={`qtd_minima_estoque-${index}`}
                                                name={`qtd_minima_estoque-${index}`}
                                                className="form-control"
                                                placeholder="Qtd mínima no estoque"
                                                value={String(produtosFormData[`qtd_minima_estoque-${index}`] ?? 0)}
                                                // value={produtosFormData[`qtd_minima_estoque-${index}`] ?? ""}
                                                // value={produtosFormData[`qtd_minima_estoque-${index}`]}
                                                // value={produtosFormData[`qtd_minima_estoque-${index}`] || ""}
                                                // value={produtosFormData[`qtd_minima_estoque-${index}`] !== null ? produtosFormData[`qtd_minima_estoque-${index}`] : null }
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor={`qtd_estoque-${index}`}>Qtd em estoque</label>
                                            <input
                                                type="text"
                                                id={`qtd_estoque-${index}`}
                                                name={`qtd_estoque-${index}`}
                                                className="form-control"
                                                placeholder="Qtd em estoque"
                                                // value={String(produtosFormData[`qtd_estoque-${index}`] ?? "")}
                                                // value={produtosFormData[`qtd_estoque-${index}`] ?? ""}
                                                // value={produtosFormData[`qtd_estoque-${index}`]}
                                                // value={produtosFormData[`qtd_estoque-${index}`] || null}
                                                value={produtosFormData[`qtd_estoque-${index}`] != null ? produtosFormData[`qtd_estoque-${index}`] : 0}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor={`descricao-${index}`}>Descrição</label>
                                            <input
                                                type="text"
                                                id={`descricao-${index}`}
                                                name={`descricao-${index}`}
                                                className="form-control"
                                                placeholder="Descrição"
                                                value={String(produtosFormData[`descricao-${index}`] ?? "Sem Descrição")}
                                                // value={produtosFormData[`descricao-${index}`] ?? ""}
                                                // value={produtosFormData[`descricao-${index}`] || ''}
                                                // value={produtosFormData[`descricao-${index}`]}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                    </div>
                                </td>
                            </tr>
                            ))
                            ) : (
                            <tr>
                                <td colSpan="4" className="text-center">
                                Nenhum produto cadastrado.
                                </td>
                            </tr>
                        )}


                    </tbody>
                </table>

                {/* Box com botão */}
                <div className="box-dados">
                    {/* Exibe o nome do perfil do usuário */}
                    <p className="texto-welcome">Clique abaixo e atualize os dados dos seus produtos.</p>
                    <button type="submit" className="welcome-btn">
                        Atualizar meus produtos
                    </button>
                </div>

            </form>

            {/* Espaço entre o botão e a tabela */}
            <div className="mt-4"></div>

        </div>
    );      


};

export default MeusProdutosPage;
